var React = require('react');

function Skype (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#03a9f4","d":"M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z","key":0}),React.createElement("circle",{"cx":"33.5","cy":"33.5","r":"11.5","fill":"#03a9f4","key":1}),React.createElement("circle",{"cx":"14.5","cy":"14.5","r":"11.5","fill":"#03a9f4","key":2}),React.createElement("path",{"fill":"#fff","d":"M24.6,36C18,36,15,32.7,15,30.2c0-1.3,0.9-2.2,2.2-2.2c2.8,0,2.1,4.1,7.4,4.1c2.7,0,4.2-1.5,4.2-3\tc0-0.9-0.4-1.9-2.2-2.4l-5.9-1.5c-4.7-1.2-5.6-3.8-5.6-6.3c0-5.1,4.7-6.9,9.1-6.9c4.1,0,8.8,2.2,8.8,5.2c0,1.3-1,2.1-2.3,2.1\tc-2.4,0-2-3.4-6.8-3.4c-2.4,0-3.8,1.1-3.8,2.7c0,1.6,1.9,2.1,3.6,2.5l4.4,1c4.8,1.1,5.9,3.9,5.9,6.6C33.9,32.9,30.9,36,24.6,36z","key":3})]);
}

Skype.defaultProps = {"viewBox":"0 0 48 48","width":"96px","height":"96px"};

module.exports = Skype;

Skype.default = Skype;
